if (document) {
	document.addEventListener('DOMContentLoaded', init);
}

let state = {
	activeVideo: 'start'
};
var reset = false;

Object.defineProperty(state, "activeVideo", {
	get() {
		return this._activeVideo;
	},
	set(newState) {
		let oldState = this._activeVideo;
		this._activeVideo = newState;
		handleVideoChange(oldState, newState);
	}
});

function handleVideoChange(oldState, newState) {
	console.log('state', oldState, newState);
	if (oldState) {
		let oldVideo = document.getElementById(oldState);
		let oldVideoElem = oldVideo.querySelector('video')
		oldVideo.classList.remove('show');
		oldVideo.classList.remove('forward');
		oldVideoElem.pause();
	}
	if (newState) {
		let newVideo = document.getElementById(newState);
		let newVideoElem = newVideo.querySelector('video')
		newVideo.classList.add('show');
		newVideoElem.play();
		console.log('reset', reset)
		if (reset) {
			newVideo.classList.add('forward');
			reset = false;
		} else {
			newVideoElem.addEventListener('ended', () => {
				newVideo.classList.remove('initial');
				newVideo.classList.add('forward');
			});
		}
	}
}

function init() {
	const app = document.querySelector('.app');
	state.activeVideo = 'start';
	if (app) {
		updateButtons = app.querySelectorAll('[data-update]');
		resetButtons = app.querySelectorAll('[data-reset]');
	}

	if (updateButtons) {
		updateButtons.forEach(button => {
			button.addEventListener('click', () => {
				state.activeVideo = button.dataset.update;
			});
		});
	}
	if (resetButtons) {
		resetButtons.forEach(button => {
			button.addEventListener('click', () => {
				reset = true;
				state.activeVideo = 'start';
			});
		});
	}
}
